import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "settings-card" }
const _hoisted_3 = { class: "feature-flags" }
const _hoisted_4 = { class: "feature-flag-row" }
const _hoisted_5 = ["aria-checked"]
const _hoisted_6 = {
  key: 0,
  class: "feature-flag-row"
}
const _hoisted_7 = ["aria-checked"]
const _hoisted_8 = {
  key: 0,
  class: "maint-status-config"
}
const _hoisted_9 = { class: "maint-status-row" }
const _hoisted_10 = { class: "maint-status-field" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "maint-status-field maint-status-field--color" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "maint-status-row" }
const _hoisted_15 = { class: "maint-status-field" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "maint-status-field maint-status-field--color" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "save-row" }
const _hoisted_20 = {
  key: 0,
  class: "save-success"
}
const _hoisted_21 = {
  key: 0,
  class: "save-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"card-header\" data-v-4d27f828><div class=\"card-icon\" data-v-4d27f828><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-4d27f828><rect x=\"2\" y=\"3\" width=\"20\" height=\"14\" rx=\"2\" data-v-4d27f828></rect><path d=\"M8 21h8M12 17v4\" data-v-4d27f828></path></svg></div><div data-v-4d27f828><h3 class=\"card-title\" data-v-4d27f828>Recursos</h3><p class=\"card-desc\" data-v-4d27f828>Ative ou desative módulos opcionais do sistema.</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "feature-flag-info" }, [
            _createElementVNode("span", { class: "feature-flag-label" }, "Modo Manutenção"),
            _createElementVNode("span", { class: "feature-flag-desc" }, "Habilita o módulo de rotinas e tarefas de manutenção preventiva para esta obra.")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["toggle-btn", { active: _ctx.form.maintenanceEnabled }]),
            role: "switch",
            "aria-checked": _ctx.form.maintenanceEnabled,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update-form', { field: 'maintenanceEnabled', value: !_ctx.form.maintenanceEnabled })))
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("span", { class: "toggle-thumb" }, null, -1)
          ]))], 10, _hoisted_5)
        ]),
        (_ctx.form.maintenanceEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "feature-flag-info" }, [
                _createElementVNode("span", { class: "feature-flag-label" }, [
                  _createTextVNode("IA de Manuais (Estagiário) "),
                  _createElementVNode("span", { class: "beta-pill" }, "Beta")
                ]),
                _createElementVNode("span", { class: "feature-flag-desc" }, "Permite enviar manuais para o EstagIArio Joe interpretar rotinas e responder dúvidas na aba Manuais do Modo Manutenção.")
              ], -1)),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["toggle-btn", { active: _ctx.form.manualsAiEnabled ?? true }]),
                role: "switch",
                "aria-checked": _ctx.form.manualsAiEnabled ?? true,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-form', { field: 'manualsAiEnabled', value: !(_ctx.form.manualsAiEnabled ?? true) })))
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("span", { class: "toggle-thumb" }, null, -1)
              ]))], 10, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.form.maintenanceEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "maint-status-title" }, "Textos e cores do status de manutenção", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "maint-status-label" }, "Texto \"Pronto\"", -1)),
                _createElementVNode("input", {
                  type: "text",
                  class: "maint-status-input",
                  value: _ctx.form.maintenanceProntoText || 'Pronto',
                  placeholder: "Pronto",
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update-form', { field: 'maintenanceProntoText', value: ($event.target as HTMLInputElement).value })))
                }, null, 40, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "maint-status-label" }, "Cor", -1)),
                _createElementVNode("input", {
                  type: "color",
                  class: "maint-color-input",
                  value: _ctx.form.maintenanceProntoColor || '#16a34a',
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update-form', { field: 'maintenanceProntoColor', value: ($event.target as HTMLInputElement).value })))
                }, null, 40, _hoisted_13)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "maint-status-label" }, "Texto \"Pendente\"", -1)),
                _createElementVNode("input", {
                  type: "text",
                  class: "maint-status-input",
                  value: _ctx.form.maintenancePendenteText || 'Pendente procedimento',
                  placeholder: "Pendente procedimento",
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update-form', { field: 'maintenancePendenteText', value: ($event.target as HTMLInputElement).value })))
                }, null, 40, _hoisted_16)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "maint-status-label" }, "Cor", -1)),
                _createElementVNode("input", {
                  type: "color",
                  class: "maint-color-input",
                  value: _ctx.form.maintenancePendenteColor || '#dc2626',
                  onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update-form', { field: 'maintenancePendenteColor', value: ($event.target as HTMLInputElement).value })))
                }, null, 40, _hoisted_18)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: "btn-save",
          type: "button",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('save')))
        }, [...(_cache[16] || (_cache[16] = [
          _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2"
          }, [
            _createElementVNode("path", { d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" }),
            _createElementVNode("polyline", { points: "17 21 17 13 7 13 7 21" }),
            _createElementVNode("polyline", { points: "7 3 7 8 15 8" })
          ], -1),
          _createTextVNode(" Salvar ", -1)
        ]))]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.successText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.successText), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.errorText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.errorText), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}